import { render, staticRenderFns } from "./SiteDiscount.vue?vue&type=template&id=ca64ac26"
import script from "./SiteDiscount.vue?vue&type=script&lang=ts"
export * from "./SiteDiscount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports